// extracted by mini-css-extract-plugin
export default {"imageContainer":"NotFound_imageContainer__fInL-","imageClass":"NotFound_imageClass__65NW5"};